import {StoreFinderConfig} from "@spartacus/storefinder/core";

export const customStoreFinderConfig: StoreFinderConfig = {
  googleMaps: {
    apiUrl: 'https://maps.googleapis.com/maps/api/js',
    apiKey: 'AIzaSyD-gU6SlFnIAWXifG4Ov3F5wzfzj9qe_hQ',
    scale: 5,
    selectedMarkerScale: 15,
    radius: 500,
  },
};
